import script from "./price-save-text.vue?vue&type=script&setup=true&lang=js"
export * from "./price-save-text.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__